<template>
  <accordion :id="accordionId" :group="accordionGroup">
    <template v-slot:trigger>
      <span class="icon-creator sw--margin-right-3 sw--font-size-20"></span>
      <span>Let us fix it</span>
    </template>
    <template v-slot:target>
      <div class="sw--margin-bottom-7 sw--margin-left-7 sw--margin-left-0--tab">
        <div class="sw--margin-bottom-2 sw-dms--color-grey-46">
          Our in-house team of designers can repair and update your model to address issues seen in the rejection image(s) provided.
          Please note that order arrival date will change depending on the current capacity of the design team.
        </div>
        <a class="sw-dms-button sw-dms-button--big" @click.prevent="displayModal(modalText)">
          <span class="sw-dms--color-grey-46">Let Shapeways fix your model</span>
        </a>
      </div>
    </template>
  </accordion>
</template>

<script>
    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import confirmTemplate from 'rrViewComponents/Model/Fix/ModelFixLetUsFixComponent/confirm-let-us-fix-noty.mustache';
    import Accordion from "rrViewComponents/Accordion/Accordion";

    export default {
        name: 'model-fix-let-us-fix',
        components: {Accordion},
        mixins: [VueJQueryMixin, VueSwMixin],

        props: {
            url: {
                type: String
            },
            accordionId: {
                type: String,
                required: true
            },
            accordionGroup: {
                type: String,
                required: true
            }
        },
        data: () => ({
            modalText: 'Are you sure you would like a Shapeways designer to repair this model based on the design issues provided?',
            errorMessage: null
        }),
        methods: {
            displayModal(content) {
                const _this = this;
                _this.errorMessage = null;
                let confirmed = false;
                let $confirmBtn = null;
                _this.$sw.notifications.full(content, {
                    modal: true,
                    layout: 'center',
                    template: confirmTemplate,
                    closeWith: ['button', 'backdrop'],
                    showCloseButton: true,
                    callback: {
                        afterShow: function () {
                            $confirmBtn = _this.$jQuery('[data-sw-noty-confirm-btn]');
                            $confirmBtn.on('click', function () {
                                confirmed = true;
                            })
                        },
                        afterClose: function () {
                            if ($confirmBtn) {
                                $confirmBtn.off('click');
                            }
                            if (confirmed) {
                                _this.submitModal();
                            }
                        }
                    }
                });
            },
            submitModal() {
                const _this = this;
                this.$jQuery.ajax({
                    type: 'POST',
                    url: _this.url,
                    dataType: 'json',
                    success: (data) => {
                        _this.$emit('success', data);
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', response);
                    }
                });
            }
        }
    }
</script>
